export default __webpack_public_path__ + "static/media/icon-1.c5c00de4.svg";